// tslint:disable: variable-name
import { Injectable } from '@angular/core';
import { SecurityAccessLevelEnum } from '../enum/security-access-level.enum';
import { AccessControlEntry } from '../access-control-entry';

@Injectable({ providedIn: 'root' })
export class SecurityElementNames {
  // #region PROFILE_TAB_ELEMENTS
  Profiles_Module = 'Profiles_Module';
  ProfileGeneral_Tab = 'ProfileGeneral_Tab';
  ProfileDetails_Tab = 'ProfileDetails_Tab';
  ProfilePhone_Number_Tab = 'ProfilePhone_Number_Tab';
  ProfileAddresses_Tab = 'ProfileAddresses_Tab';
  ProfileRelated_Profiles_Tab = 'ProfileRelated_Profiles_Tab';
  ProfileAffiliations_Tab = 'ProfileAffiliations_Tab';
  ProfileCommittees_Tab = 'ProfileCommittees_Tab';
  ProfileTasks_Tab = 'ProfileTasks_Tab';
  ProfileContacts_Tab = 'ProfileContacts_Tab';
  ProfileNotes_Tab = 'ProfileNotes_Tab';
  ProfileMember_Tab = 'ProfileMember_Tab';
  ProfileMember_Activity_Tab = 'ProfileMember_Activity_Tab';
  ProfileListings_Tab = 'ProfileListings_Tab';
  ProfileReferrals_Tab = 'ProfileReferrals_Tab';
  ProfileBilling_Tab = 'ProfileBilling_Tab';
  ProfileTransactions_Tab = 'ProfileTransactions_Tab';
  ProfileEvents_Tab = 'ProfileEvents_Tab';
  ProfilePortal_Tab = 'ProfilePortal_Tab';
  ProfileCustom_Info_Tab = 'ProfileCustom_Info_Tab';
  ProfileURL_Tab = 'ProfileURL_Tab';

  // #endregion

  Delete_Profile = 'Delete_Profile';
  Set_Profile_As_Prospect = 'Set_Profile_As_Prospect';
  Set_Profile_As_Member = 'Set_Profile_As_Member';
  New_Organization_Wizard = 'New_Organization_Wizard';

  Contacts_Module = 'Contacts_Module';
  Close_Sales_Opportunity = 'Close_Sales_Opportunity';

  Tasks_And_Projects_Module = 'Tasks_And_Projects_Module';
  Events_Module = 'Events_Module';
  Committees_Module = 'Committees_Module';
  Revenue_Module = 'Revenue_Module';

  Credit_Card_Processing = 'Credit_Card_Processing';
  Credit_Card_Refund_Processing = 'Credit_Card_Refund_Processing';
  Mass_Change_Payment_Types = 'Mass_Change_Payment_Types';

  Reports_Module = 'Reports_Module';

  Communications_Module = 'Communications_Module';

  Weblink_Messenger = 'Weblink_Messenger';
  Send_Mass_Communicatons = 'Send_Mass_Communicatons';
  Message_Status = 'Message_Status';
  Send_Fax = 'Send_Fax';
  Fax_Status = 'Fax_Status';
  Web_Content_Management = 'Web_Content_Management';
  Web_Input = 'Web_Input';
  Web_Template_Manager = 'Web_Template_Manager';

  Manage_Web_Components = 'Manage_Web_Components';
  Browse_Directory_Web_Components = 'Browse_Directory_Web_Components';
  Browse_Calendar_Web_Components = 'Browse_Calendar_Web_Components';
  Browse_ENews_Web_Components = 'Browse_ENews_Web_Components';
  Web_Files_Manager = 'Web_Files_Manager';
  News_Articles = 'News_Articles';
  Alerts = 'Alerts';
  Surveys = 'Surveys';
  BusinessConnectRequests = 'BusinessConnectRequests';
  Banner_Ads = 'Banner_Ads';
  Coupons = 'Coupons';
  Create_Portal_Logins = 'Create_Portal_Logins';

  HTML_Editor = 'HTML_Editor';

  Admin_Module = 'Admin_Module';

  // #region ADMIN_MENU_ELEMENTS

  Association_Info = 'Association_Info';
  Manage_Users = 'Manage_Users';

  // #endregion

  // #region BEGIN_ADMIN_MENU_SUB-ELEMENTS
  Manage_User_Codes = 'Manage_User_Codes';
  Manage_Profile_Codes = 'Manage_Profile_Codes';
  Manage_Member_Codes = 'Manage_Member_Codes';
  Manage_Member_Source_Codes = 'Manage_Member_Source_Codes';
  Manage_Referral_Type_Codes = 'Manage_Referral_Type_Codes';
  Manage_Category_Codes = 'Manage_Category_Codes';
  Manage_Member_Activity_Codes = 'Manage_Member_Activity_Codes';
  Manage_Committee_Type_Codes = 'Manage_Committee_Type_Codes';
  Manage_Contact_Codes = 'Manage_Contact_Codes';
  Manage_Task_Codes = 'Manage_Task_Codes';
  Manage_Project_Codes = 'Manage_Project_Codes';
  Manage_Event_Codes = 'Manage_Event_Codes';
  Manage_Revenue_Codes = 'Manage_Revenue_Codes';
  Manage_Web_Portal_Codes = 'Manage_Web_Portal_Codes';
  Manage_Sales_Opportunity_Codes = 'Manage_Sales_Opportunity_Codes';

  Manage_Custom_Fields = 'Manage_Custom_Fields';
  Set_Preferences = 'Set_Preferences';
  Download_Core_Data = 'Download_Core_Data';
  Encryption_Tool = 'Encryption_Tool';

  // #endregion

  // #region REPORT_MENU_ELEMENTS

  Profile_Reports = 'Profile_Reports';
  Member_Reports = 'Member_Reports';
  Referral_Reports = 'Referral_Reports';
  Contact_Reports = 'Contact_Reports';
  Task_Reports = 'Task_Reports';
  Event_Reports = 'Event_Reports';
  Committee_Reports = 'Committee_Reports';
  Revenue_Reports = 'Revenue_Reports';

  Web_Reports = 'Web_Reports';
  Directory_Web_Reports = 'Directory_Web_Reports';
  Referral_Web_Reports = 'Referral_Web_Reports';
  Event_Web_Reports = 'Event_Web_Reports';
  Communication_Web_Reports = 'Communication_Web_Reports';

  Admin_Reports = 'Admin_Reports';
  Custom_Reports = 'Custom_Reports';
  Summary_Statistics = 'Summary_Statistics';
  Report_Writer = 'Report_Writer';
  Data_Dictionary = 'Data_Dictionary';
  Update_Reports = 'Update_Reports';
  Upload_Custom_Report = 'Upload_Custom_Report';

  Dashboard_Retention = 'Dashboard_Retention';
  Dashboard_Membership = 'Dashboard_Membership';
  Dashboard_Financial = 'Dashboard_Financial';

  None = 'None';

  Query_Tool = 'Query_Tool';
  MySavedQueries_Module = 'MySavedQueries_Module';

  // #endregion
  accessControlCache: { [key: string]: AccessControlEntry } = {};

  getAccessControl(elementName: string, accessLevel: SecurityAccessLevelEnum): AccessControlEntry {
    const key = `${elementName}_${accessLevel}`;
    if (!this.accessControlCache[key]) {
      this.accessControlCache[key] = { SecurityElement: elementName, MinimumAccessLevel: accessLevel } as AccessControlEntry;
    }
    return this.accessControlCache[key];
  }

  readonly(elementName: string): AccessControlEntry {
    return this.getAccessControl(elementName, SecurityAccessLevelEnum.ReadOnlyAccess);
  }

  fullAccess(elementName: string): AccessControlEntry {
    return this.getAccessControl(elementName, SecurityAccessLevelEnum.FullAccess);
  }
}
